import { render, staticRenderFns } from "./ProjectRealEstates.vue?vue&type=template&id=76d30abc&scoped=true"
import script from "./ProjectRealEstates.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstates.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRealEstates.vue?vue&type=style&index=0&id=76d30abc&prod&scoped=true&lang=css"
import style1 from "./ProjectRealEstates.vue?vue&type=style&index=1&id=76d30abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d30abc",
  null
  
)

export default component.exports